var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1641 20H1.16406M1.16406 9L5.22706 5.75M21.1641 9L13.0381 2.5C12.5061 2.07449 11.8452 1.84267 11.1641 1.84267C10.4829 1.84267 9.82199 2.07449 9.29006 2.5L8.50806 3.125M14.6641 3.5V1.5C14.6641 1.36739 14.7167 1.24021 14.8105 1.14645C14.9043 1.05268 15.0315 1 15.1641 1H17.6641C17.7967 1 17.9238 1.05268 18.0176 1.14645C18.1114 1.24021 18.1641 1.36739 18.1641 1.5V6.5M3.16406 20V7.5M19.1641 7.5V11.5M19.1641 20V15.5",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 20V15C14.1641 13.586 14.1641 12.879 13.7241 12.44C13.2861 12 12.5791 12 11.1641 12C9.75006 12 9.04306 12 8.60406 12.44M8.16406 20V15",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 7.5C13.1641 8.03043 12.9533 8.53914 12.5783 8.91421C12.2032 9.28929 11.6945 9.5 11.1641 9.5C10.6336 9.5 10.1249 9.28929 9.74985 8.91421C9.37478 8.53914 9.16406 8.03043 9.16406 7.5C9.16406 6.96957 9.37478 6.46086 9.74985 6.08579C10.1249 5.71071 10.6336 5.5 11.1641 5.5C11.6945 5.5 12.2032 5.71071 12.5783 6.08579C12.9533 6.46086 13.1641 6.96957 13.1641 7.5Z",
    stroke: "#111111",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1207380bd78021ddc7ae4152665c12f0.svg";
export { ForwardRef as ReactComponent };